import React, { useState } from 'react';
import { Modal, Grid, Stack, Chip, Divider } from '@mui/material';
import ImageCropper from './ImageCropper';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { useEffect } from 'react';
import axios from '../../axios';
import InfoIcon from '@mui/icons-material/Info';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Button,
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Dialog, LinearProgress, Typography } from '@mui/material';

const ImagePreview = () => {
  const [tokent, settokent] = useState(
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ',
  );
  const [open, setOpen] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const [croppedImages, setCroppedImages] = useState([]);
  const [openLoader, setOpenLoader] = useState(false);

  const [deleted, setdeleted] = useState(false);

  const [deletedconfirm, setdeletedconfirm] = useState(false);
  useEffect(() => {
    getalldata();
  }, []);

  const changepage = () => {
    return tabledata.slice(page * rowsperpage, (page + 1) * rowsperpage);
  };

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
    // setpage(0);
  };

  //pages
  const pages = [
    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 100, 150, 200, 250, 300, 400, 500,
    600, 700, 800, 900, 1000,
  ];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);

  //Update and deleteid
  const [deleteid, setdeleteid] = useState('');

  //tabledata
  const [tabledata, settabledata] = useState([]);

  const onFileChange = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setImageSrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setOpen(true);
    }
  };

  const onCropComplete = (pool, croppedImageFile) => {
    if (pool) {
      console.log('true');
      getalldata();
    }
    setOpen(false);
    console.log('yuki');
    setImageSrc(null);
  };

  const getalldata = async () => {
    setOpenLoader(true);
    await axios.instance
      .get(
        `GetAllAdsBanner/${sessionStorage.getItem(
          'Companyid',
        )}/${sessionStorage.getItem('Branch_Log')}`,
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then(res => {
        settabledata(res.data, 'tabledata');
        console.log(res.data);
        setOpenLoader(false);
      });
  };

  const deletecususerreg = async () => {
    await axios.instance
      .delete(`DeleteAdsBanner/${deleteid}`, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'application/json',
        },
      })
      .then(res => {
        getalldata();
        setdeleted(true);
      });
  };

  const UpdateActive = async id => {
    await axios.instance
      .put(`Updateactive/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      })
      .then(res => {
        getalldata();
        setpage(0);
      });
  };

  return (
    <React.Fragment>
      <div>
        <Container fluid={true}>
          <h6 className="monthwisetitle">Ads Banner</h6>
          <Card>
            <CardBody>
              <div>
                <Stack
                  direction={{ sm: 'column', xs: 'column' }}
                  justifyContent="end"
                  alignItems="end"
                >
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    component="label"
                  >
                    Add Image
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      onChange={onFileChange}
                    />
                  </Button>
                  <Typography
                    variant="subtitle1"
                    color="#436850"
                    textAlign={'right'}
                    className="mt-1"
                    style={{ fontSize: '12px' }}
                  >
                    <b>Note:</b> The ad image should be <b>728px </b> in width
                    and <b>80px</b> in height. Please ensure your image meets
                    these dimensions for optimal display.
                  </Typography>
                </Stack>

                <Modal open={open} onClose={() => setOpen(false)}>
                  <div
                    style={{
                      padding: 20,
                      // backgroundColor: 'white',
                      // margin: 'auto',
                      marginTop: '38%',
                      marginLeft: '45%',
                    }}
                  >
                    {imageSrc && (
                      <ImageCropper
                        imageSrc={imageSrc}
                        onCropComplete={onCropComplete}
                        onClose={() => setOpen(false)}
                      />
                    )}
                  </div>
                </Modal>
                <Grid container spacing={2} style={{ marginTop: 5 }}>
                  {croppedImages.map((image, index) => (
                    <Grid item key={index}>
                      <img
                        src={image.url}
                        alt={`Cropped ${index}`}
                        style={{ width: 728, height: 80, objectFit: 'contain' }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </div>

              <TableContainer style={{ marginTop: '20px' }}>
                <Table className="table-borderless" responsive>
                  <TableBody>
                    {tabledata.length != 0 ? (
                      changepage().map(data => (
                        <TableRow>
                          <TableCell>
                            <Row
                              className={`card d-flex flex-row justify-content-center align-content-center ${
                                data.Active === 'Y' ? 'p-4' : 'p-2'
                              }`}
                              style={{
                                borderRadius: '15px',
                                boxShadow:
                                  data.Active === 'Y'
                                    ? 'rgb(33 34 34 / 78%) 0px 0.0625em 0.0625em, rgb(22 225 0) 0px 0.125em 0.5em, rgb(53 255 42 / 93%) 0px 0px 0px 1px inset'
                                    : 'rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset',
                              }}
                            >
                              <Col lg="12">
                                {data.Active === 'Y' && (
                                  <Divider className="my-2 mb-4">
                                    <Chip
                                      label="Active Banner"
                                      color="success"
                                      size="small"
                                      variant="outlined"
                                    />
                                  </Divider>
                                )}
                              </Col>
                              <Col lg="10">
                                <img
                                  src={
                                    axios.baseURL +
                                    'AdsBannerImage/' +
                                    data.Ads_Image
                                  }
                                  alt="Ad Banner"
                                  style={{
                                    width: '100%',
                                    maxHeight: '80',
                                    objectFit: 'contain',
                                    boxShadow:
                                      'rgba(0, 0, 0, 0.18) 0px 2px 4px',
                                    borderRight: '1px solid grey',
                                  }}
                                />
                              </Col>
                              <Col
                                lg="2"
                                className=" d-flex flex-row justify-content-center align-content-center p-2"
                              >
                                <Stack
                                  direction={'column'}
                                  spacing={2}
                                  justifyContent={'center'}
                                  alignItems={'center'}
                                >
                                  {data.Active == 'Y' ? (
                                    <Chip label="Active" color="success" />
                                  ) : (
                                    <Button
                                      variant="contained"
                                      style={{
                                        backgroundColor: 'blue',
                                        borderRadius: '15px',
                                        color: 'white',
                                      }}
                                      size="small"
                                      onClick={() => {
                                        // setdeletedconfirm(true);
                                        UpdateActive(data.Ads_Id);
                                      }}
                                    >
                                      Set Active
                                    </Button>
                                  )}

                                  <Button
                                    variant="contained"
                                    style={{
                                      backgroundColor: 'red',
                                      borderRadius: '15px',
                                      color: 'white',
                                    }}
                                    size="small"
                                    startIcon={<DeleteIcon />}
                                    onClick={() => {
                                      setdeletedconfirm(true);
                                      setdeleteid(data.Ads_Id);
                                    }}
                                  >
                                    Delete
                                  </Button>
                                </Stack>
                              </Col>
                            </Row>
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableCell align="left">NO Data Found</TableCell>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                component="div"
                rowsPerPageOptions={pages}
                count={tabledata.length}
                rowsPerPage={rowsperpage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </CardBody>
          </Card>
        </Container>
      </div>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {deletedconfirm ? (
        <SweetAlert
          title="Are You Sure?"
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          confirmBtnBsStyle="success"
          showConfirm={true}
          cancelBtnBsStyle="danger"
          cancelBtnText="Cancel"
          confirmBtnText="Yes,delete it!"
          showCancel={true}
          warning
          onConfirm={() => {
            deletecususerreg();
            setdeletedconfirm(false);
          }}
          onCancel={() => {
            setdeletedconfirm(false);
            setdeleted(false);
          }}
        >
          <p style={{ fontSize: '20px' }}>You Won't able to revert this!</p>
        </SweetAlert>
      ) : null}

      {deleted ? (
        <SweetAlert
          title=" Data Deleted Successfully"
          timeout={2000}
          style={{
            position: 'absolute',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          showCloseButton={false}
          showConfirm={false}
          success
          onConfirm={() => {
            setdeleted(false);
          }}
        >
          {' '}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  );
};

export default ImagePreview;
